import {LOCK_INIT, LOCK_NO, LOCK_YES, ROLE_ADMIN, ROLE_USER, SEX_FEMALE, SEX_MALE} from "@/constants/user";
import {getLockStatusName} from "@/utils/user";

export default class User {

    constructor(options) {
        this._id = options?._id || 0
        this.mobile = options?.mobile || ""
        this.name = options?.name || ""
        this.avatarKey = options?.avatarKey || ""
        this.avatarUrl = options?.avatarUrl || ""
        this.roleId = options?.roleId || 0
        this.sexId = options?.sexId || 0
        this.introducerId = options?.introducerId || 0
        this.locked = options?.locked || 0
        this.lockComment = options?.lockComment || ""
        this.invCode = options?.invCode || ""
        this.introCode = options?.introCode || ""
        this.canEditIntroCode = options?.canEditIntroCode || false
        this.realNameId = options?.realNameId || 0
        this.refereeId = options?.refereeId || 0
        this.companyId = options?.companyId || 0
    }

    get isNew() {
        return this._id <= 0
    }

    get sexName() {
        switch (this.sexId) {
            case SEX_MALE:
                return "男"
            case SEX_FEMALE:
                return "女"
            default:
                return "未知"
        }
    }

    get roleName() {
        switch (this.roleId) {
            case ROLE_USER:
                return "普通用户"
            case ROLE_ADMIN:
                return "管理员"
            default:
                return "游客"
        }
    }

    get statusShort() {
        return getLockStatusName(this.locked)
    }

    get isLocked() {
        return this.locked == LOCK_YES
    }

    get isUnlocked() {
        return !this.isLocked
    }

    toData() {
        return {
            _id: this._id,
            mobile: this.mobile,
            name: this.name,
            avatarKey: this.avatarKey,
            avatarUrl: this.avatarUrl,
            roleId: this.roleId,
            sexId: this.sexId,
            introducerId: this.introducerId,
            locked: this.locked,
            lockComment: this.lockComment,
            invCode: this.invCode,
            introCode: this.introCode,
            canEditIntroCode: this.canEditIntroCode,
            realNameId: this.realNameId,
            refereeId: this.refereeId,
            companyId: this.companyId,
        }
    }

    toJSON () {
        return { ...this }
    }
}
